var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-mb-md"},[_c('q-select',{attrs:{"filled":"","value":_vm.value,"options":_vm.options,"label":_vm.t('label'),"clearable":"","emit-value":"","map-options":""},on:{"input":_vm.setOption}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }